module.exports = __webpack_public_path__ + "img/sango.8f24bf77.png";